<ion-item>
  <ion-select [label]="item.name | translate" [value]="item.selected" (ionChange)="item.change($event)">
    <ion-select-option *ngFor="let o of item.options" [value]="o.value" [translate]="o.text"></ion-select-option>
  </ion-select>
</ion-item>
